<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      :mini-variant="mini"
      mini-variant-width="50"
      app
      hide-overlay
      stateless
    >
      <v-list class="pt-0" dense>
        <v-divider />

        <v-list-item
          v-for="item in items"
          :key="item.title"
          @click="item.onPressed != null ? item.onPressed() : $router.push(item.path)"
        >
          <v-tooltip right>
            <template v-slot:activator="{ on }">
              <v-list-item-action v-on="on">
                <v-icon color="grey darken-3">{{ item.icon }}</v-icon>
              </v-list-item-action>
            </template>
            <p>{{ item.title }}</p>
          </v-tooltip>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item style="padding-left: 6px;">
          <v-switch v-model="isAutoDispatchEnabled" />
        </v-list-item>
      </v-list>
      <v-btn
        icon
        color="primary"
        style="position:absolute; bottom:24px; right: 4px;"
        @click.stop="mini = !mini"
      >
        <v-icon background-color="cyan">{{ mini ? 'chevron_right' : 'chevron_left' }}</v-icon>
      </v-btn>
    </v-navigation-drawer>
  </div>
</template>


<script>
export default {
  name: "AppNavigation",
  data() {
    var store = this.$store;

    return {
      mini: true,
      title: this.$store.state.title,
      name: this.$store.state.user.name,
      drawer: true,
      items: [
        { title: "Overwatch", path: "/", icon: "dashboard" },
        { title: "Map", path: "/overwatch_map", icon: "map" },
        {
          title: "Overwatch (no map)",
          path: "/overwatch_no_map",
          icon: "vertical_split",
        },
        { title: "Bookings", path: "/bookings", icon: "list" },
        { title: "Invoicing", path: "/invoices", icon: "receipt" },
        { title: "Drivers", path: "/drivers", icon: "local_taxi" },
        {
          title: "Messaging",
          icon: "chat",
          onPressed: function () {
            console.log("Chat");
          },
        },
        { title: "Calendar", path: "/calendar", icon: "calendar_today" },
        { title: "Repeat Trips", path: "/repeat_service", icon: "repeat" },
        { title: "Customers", path: "/customers", icon: "person" },
        {
          title: "Business Customers",
          path: "/corporateCustomers",
          icon: "business_center",
        },
        { title: "Ratings", path: "/ratings", icon: "star" },
        // { title: "Statistics", path: "/statistics", icon: "pie_chart" },
        { title: "Settings", path: "/settings", icon: "settings" },
        // {
        //   title: "Search",
        //   onPressed: function() {},
        //   icon: "search"
        // },
        {
          title: "Log Out",
          icon: "exit_to_app",
          onPressed: function () {
            store.dispatch("logout", {});
          },
        },
      ],
    };
  },
  computed: {
    isLoggedIn: function () {
      return this.$store.getters.getLoggedIn;
    },
    isAutoDispatchEnabled: {
      get: function () {
        return this.$store.getters.getAutoDispatchEnabled;
      },
      set: function (value) {
        this.$store.dispatch("toggleAutodispatch", { value: value });
      },
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.v-navigation-drawer--mini-variant .v-list__tile {
  padding-left: 1px !important;
}
</style>
